





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import RateCards from '@/components/RateCards/AgencyRateCards.vue';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyRateCardSettings',
  	components: { RateCards, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getRateCards();
		AgencySettingsModule.getPositions();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingRateCards;
  	}
}
